import baseAPI from '@/api/base';
import {
  EditYurtzeiten_N,
  GetYurtzeiten_N,
  GetYurtzeitenDisplay_N,
  GetYurtzeitenStats_N,
  ImportYurtzeitens_N,
} from '@/dtos/yurtzeiten_N.dto';
import {
  APPROVE_YURTZEITEN_N_URL,
  DELETE_YURTZEITEN_N_URL,
  EDIT_YURTZEITEN_N_URL,
  GET_YURTZEITEN_N_STATS_URL,
  GET_YURTZEITEN_N_DISPLAY_URL,
  GET_YURTZEITEN_N_URL,
  IMPORT_YURTZEITEN_N_URL,
  MARK_VIEWED_YURTZEITEN_N_URL,
  REGISTER_YURTZEITEN_N_URL,
  REJECT_YURTZEITEN_N_URL,
  TOGGLE_YURTZEITEN_N_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Yurtzeiten_N {
  static getYurtzeitenDisplay_N = async (
    payload: GetYurtzeitenDisplay_N
  ): Promise<AxiosResponse> => {
    return baseAPI.get(GET_YURTZEITEN_N_DISPLAY_URL, {
      params: payload,
    });
  };

  static getYurtzeitens_N = async (
    getYurtzeiten_N: GetYurtzeiten_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_YURTZEITEN_N_URL, {
      params: getYurtzeiten_N,
    });
    return response;
  };

  static getYurtzeitenStats_N = async (
    getYurtzeitenStats_N: GetYurtzeitenStats_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(
      GET_YURTZEITEN_N_STATS_URL,
      {
        params: getYurtzeitenStats_N,
      }
    );
    return response;
  };

  static registerYurtzeiten_N = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_YURTZEITEN_N_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  // A CSV import, as JSON. Given longer than the default timeout: the real run
  // writes every row of the file in one transaction.
  static importYurtzeitens_N = async (
    payload: ImportYurtzeitens_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(IMPORT_YURTZEITEN_N_URL, payload, {
      timeout: 180000,
    });
    return response;
  };

  static editYurtzeiten_N = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_YURTZEITEN_N_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  static toggleYurtzeiten_NIsActive = async (
    payload: Pick<EditYurtzeiten_N, 'id'> | EditYurtzeiten_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_YURTZEITEN_N_IS_ACTIVE_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  static approveYurtzeiten_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      `${APPROVE_YURTZEITEN_N_URL}/${id}`
    );
    return response;
  };

  static rejectYurtzeiten_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      `${REJECT_YURTZEITEN_N_URL}/${id}`
    );
    return response;
  };

  static markViewedYurtzeiten_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      `${MARK_VIEWED_YURTZEITEN_N_URL}/${id}`
    );
    return response;
  };

  static deleteYurtzeiten_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_YURTZEITEN_N_URL}/${id}`
    );
    return response;
  };
}

export default Yurtzeiten_N;
